import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './components/HomePage';
import NoticeList from './components/NoticeList';
import NoticeDetail from './components/NoticeDetail';
import Greeting from './components/pages/Greeting';
import Vision from './components/pages/Vision';
import History from './components/pages/History';
import Organization from './components/pages/Organization';
import Office from './components/pages/Office';
import SmartphoneFree from './components/pages/SmartphoneFree';
import Activities from './components/pages/Activities';
import PressRelease from './components/pages/PressRelease';
import MediaCoverage from './components/pages/MediaCoverage';
import Resources from './components/pages/Resources';

function App() {
  return (
    <Router>
      <div className="App">
        <Header />
        
        <main className="main-content">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/notice" element={<NoticeList />} />
            <Route path="/notice/:id" element={<NoticeDetail />} />
            <Route path="/greeting" element={<Greeting />} />
            <Route path="/vision" element={<Vision />} />
            <Route path="/history" element={<History />} />
            <Route path="/organization" element={<Organization />} />
            <Route path="/office" element={<Office />} />
            <Route path="/smartphone-free" element={<SmartphoneFree />} />
            <Route path="/activities" element={<Activities />} />
            <Route path="/press-release" element={<PressRelease />} />
            <Route path="/press-release/:id" element={<PressRelease />} />
            <Route path="/media-coverage" element={<MediaCoverage />} />
            <Route path="/media-coverage/:id" element={<MediaCoverage />} />
            <Route path="/resources" element={<Resources />} />
            <Route path="/resources/:id" element={<Resources />} />
          </Routes>
        </main>
        
        <Footer />
      </div>
    </Router>
  );
}

export default App;
